import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { INIT_TZS, ITimezoneStore, MAX_TIMEZONES } from '../config';

export const useTimezoneStore = create<ITimezoneStore>()(
  persist(
    (set) => ({
      selected: INIT_TZS,
      addTimezone: (tz) => {
        set((state) => {
          const alreadySelected = state.selected.some(
            (item) => item.tzCode === tz.tzCode,
          );
          if (alreadySelected || state.selected.length >= MAX_TIMEZONES) {
            return state;
          }
          return { selected: [...state.selected, tz] };
        });
      },
      removeTimezone: (tzCode) => {
        set((state) => ({
          selected: state.selected.filter((item) => item.tzCode !== tzCode),
        }));
      },
    }),
    {
      name: 'worldtime',
    },
  ),
);
